import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { blogs, blogPath, formatDate, isPublished } from '../lib/blogs';
import useTitle from '../lib/useTitle';
import './BlogIndex.css';

function EntryBody({ blog, published }) {
  return (
    <>
      <div className="entry__thumb mono">
        {blog.image ? <img src={blog.image} alt="" loading="lazy" /> : <span aria-hidden="true" />}
      </div>
      <div className="entry__body">
        {published ? (
          <time className="entry__date" dateTime={blog.publishDate}>
            {formatDate(blog.publishDate)}
          </time>
        ) : (
          <span className="entry__date entry__date--draft">in progress</span>
        )}
        <h2 className="entry__title">{blog.title}</h2>
        {blog.excerpt && <p className="entry__abstract">{blog.excerpt}</p>}
        {published && (
          <span className="entry__read">
            Read <ArrowRight size={14} aria-hidden="true" />
          </span>
        )}
      </div>
    </>
  );
}

export default function BlogIndex() {
  useTitle('Writing');
  return (
    <main id="content" className="index">
      <header className="index__head reveal">
        <p className="index__kicker">writing</p>
        <h1 className="index__title">Infosec Rewind</h1>
        <p className="index__lead">
          The storage for my abrupt cybersecurity knowledge — notes, writeups, and experiments in
          web and AI security.
        </p>
      </header>

      {blogs.length === 0 ? (
        <p className="index__empty">Nothing here yet. Check back soon.</p>
      ) : (
        <ol className="index__list reveal" style={{ '--d': 1 }}>
          {blogs.map((blog) => {
            const published = isPublished(blog);
            return (
              <li key={blog.id} className={`entry${published ? '' : ' is-draft'}`}>
                {published ? (
                  <Link className="entry__link" to={blogPath(blog)}>
                    <EntryBody blog={blog} published />
                  </Link>
                ) : (
                  <div className="entry__link">
                    <EntryBody blog={blog} published={false} />
                  </div>
                )}
              </li>
            );
          })}
        </ol>
      )}
    </main>
  );
}
